/* eslint-disable no-unused-vars */
import { useState, useEffect, useRef } from "react";
import Navbar from "../../components/navigationBar";
import "./BuatPembayaranNasabah.scss";
import { fetchUsers, tambahPembayaran } from "../../api";
import Swal from "sweetalert2";
import { motion, AnimatePresence } from "framer-motion";
import { CreditCard, Search, Upload, User, Save } from "lucide-react";

export default function BuatPembayaranNasabah() {
  const [nik, setNik] = useState("");
  const [nama, setNama] = useState("");
  const [produkPinjaman, setProdukPinjaman] = useState("");
  const [totalTagihan, setTotalTagihan] = useState("");
  const [tanggalJatuhTempo, setTanggalJatuhTempo] = useState("");
  const [msg, setMsg] = useState("");
  const [loading, setLoading] = useState(false);

  // State untuk user search
  const [userList, setUserList] = useState([]);
  const [search, setSearch] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);

  // Tambahkan state
  const [fotoNasabah, setFotoNasabah] = useState(null);
  const [fotoKtp, setFotoKtp] = useState(null);

  // Tambahkan state untuk preview
  const [previewFotoNasabah, setPreviewFotoNasabah] = useState(null);
  const [previewFotoKtp, setPreviewFotoKtp] = useState(null);

  // Tambahkan state untuk bank dan nomor virtual account
  const [bankVirtualAccount1, setBankVirtualAccount1] = useState("");
  const [bankVirtualAccount2, setBankVirtualAccount2] = useState("");
  const [nomorVirtualAccount1, setNomorVirtualAccount1] = useState("");
  const [nomorVirtualAccount2, setNomorVirtualAccount2] = useState("");

  // Ambil daftar user saat komponen mount
  useEffect(() => {
    const fetchUserList = async () => {
      try {
        const token =
          localStorage.getItem("adminToken") ||
          sessionStorage.getItem("adminToken");
        const users = await fetchUsers(token);
        setUserList(users);
      } catch (err) { }
    };
    fetchUserList();
  }, []);

  // Tutup dropdown jika klik di luar
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter user berdasarkan input
  const filteredUsers = userList.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.nik.toLowerCase().includes(search.toLowerCase())
  );

  const handleUserSelect = (user) => {
    setNama(user.name);
    setNik(user.nik);
    setSearch(user.name + " - " + user.nik);
    setShowDropdown(false);
  };

  const handleFotoKtpChange = (e) => {
    const file = e.target.files[0];
    setFotoKtp(file);
    if (file) {
      setPreviewFotoKtp(URL.createObjectURL(file));
    } else {
      setPreviewFotoKtp(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMsg("");
    setLoading(true);

    try {
      const token =
        localStorage.getItem("adminToken") ||
        sessionStorage.getItem("adminToken");

      const formData = new FormData();
      formData.append("nik", nik);
      formData.append("nama", nama);
      formData.append("produkPinjaman", produkPinjaman);
      formData.append("totalTagihan", totalTagihan);
      formData.append("tanggalJatuhTempo", tanggalJatuhTempo);
      formData.append("bank_virtual_account1", bankVirtualAccount1);
      formData.append("bank_virtual_account2", bankVirtualAccount2);
      formData.append("nomor_virtual_account1", nomorVirtualAccount1);
      formData.append("nomor_virtual_account2", nomorVirtualAccount2);
      if (fotoKtp) formData.append("fotoKtp", fotoKtp);

      await tambahPembayaran(formData, token);

      setMsg("Pembayaran berhasil ditambahkan!");
      setNik("");
      setNama("");
      setProdukPinjaman("");
      setTotalTagihan("");
      setTanggalJatuhTempo("");
      setBankVirtualAccount1("");
      setBankVirtualAccount2("");
      setNomorVirtualAccount1("");
      setNomorVirtualAccount2("");
      setSearch("");
      setFotoKtp(null);
      setPreviewFotoKtp(null);

      Swal.fire({
        icon: "success",
        title: "Berhasil",
        text: "Pembayaran nasabah berhasil ditambahkan!",
        confirmButtonColor: "#4f46e5",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Gagal",
        text: err.message || "Terjadi kesalahan. Coba lagi.",
        confirmButtonColor: "#ef4444",
      });
      setMsg(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="buat-pembayaran-root">
      <Navbar />
      <motion.form
        className="buat-pembayaran-form"
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
      >
        <h2><CreditCard size={24} style={{ marginBottom: -5, marginRight: 8 }} /> Buat Pembayaran Nasabah</h2>

        <div className="form-group relative" ref={dropdownRef}>
          <label>Cari Nama/NIK Nasabah</label>
          <div style={{ position: 'relative' }}>
            <Search size={18} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setShowDropdown(true);
              }}
              placeholder="Ketikan nama atau NIK nasabah"
              autoComplete="off"
              onFocus={() => setShowDropdown(true)}
              style={{ paddingLeft: 40 }}
            />
          </div>
          <AnimatePresence>
            {showDropdown && search && filteredUsers.length > 0 && (
              <motion.div
                className="dropdown-list"
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0 }}
              >
                {filteredUsers.map((user, idx) => (
                  <div
                    key={user.nik + idx}
                    className="dropdown-item"
                    onClick={() => handleUserSelect(user)}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    <User size={14} style={{ marginRight: 6, display: 'inline' }} />
                    <strong>{user.name}</strong> <span>({user.nik})</span>
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>NIK Nasabah</label>
            <input
              type="text"
              value={nik}
              onChange={(e) => setNik(e.target.value)}
              placeholder="NIK nasabah"
              required
            />
          </div>
          <div className="form-group">
            <label>Nama Nasabah</label>
            <input
              type="text"
              value={nama}
              onChange={(e) => setNama(e.target.value)}
              placeholder="Nama nasabah"
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label>Produk Pinjaman</label>
          <input
            type="text"
            value={produkPinjaman}
            onChange={(e) => setProdukPinjaman(e.target.value)}
            placeholder="Produk pinjaman"
            required
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Total Tagihan (Rp)</label>
            <input
              type="number"
              value={totalTagihan}
              onChange={(e) => setTotalTagihan(e.target.value)}
              placeholder="Total tagihan"
              required
            />
          </div>
          <div className="form-group">
            <label>Tanggal Jatuh Tempo</label>
            <input
              type="date"
              value={tanggalJatuhTempo}
              onChange={(e) => setTanggalJatuhTempo(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Bank VA 1</label>
            <input
              type="text"
              value={bankVirtualAccount1}
              onChange={(e) => setBankVirtualAccount1(e.target.value)}
              placeholder="Contoh: BCA"
            />
          </div>
          <div className="form-group">
            <label>No VA 1</label>
            <input
              type="text"
              value={nomorVirtualAccount1}
              onChange={(e) => setNomorVirtualAccount1(e.target.value)}
              placeholder="Nomor Virtual Account"
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Bank VA 2</label>
            <input
              type="text"
              value={bankVirtualAccount2}
              onChange={(e) => setBankVirtualAccount2(e.target.value)}
              placeholder="Contoh: Mandiri"
            />
          </div>
          <div className="form-group">
            <label>No VA 2</label>
            <input
              type="text"
              value={nomorVirtualAccount2}
              onChange={(e) => setNomorVirtualAccount2(e.target.value)}
              placeholder="Nomor Virtual Account"
            />
          </div>
        </div>

        <div className="form-group">
          <label>Foto KTP Nasabah</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <label className="custom-file-upload" style={{
              cursor: 'pointer',
              padding: '10px 15px',
              backgroundColor: '#f1f5f9',
              borderRadius: 'var(--radius-md)',
              border: '1px dashed var(--border-color)',
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: '0.9rem',
              color: 'var(--text-secondary)'
            }}>
              <Upload size={18} />
              <span>Upload KTP</span>
              <input
                type="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFotoKtpChange}
                style={{ display: 'none' }}
              />
            </label>
            {previewFotoKtp && (
              <img
                src={previewFotoKtp}
                alt="Preview KTP"
                className="img-preview"
                style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 4 }}
              />
            )}
          </div>
        </div>

        {msg && (
          <motion.div
            className={`msg ${msg.includes("berhasil") ? "success" : "error"}`}
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
          >
            {msg}
          </motion.div>
        )}

        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? "Memproses..." : <><Save size={18} /> Simpan Pembayaran</>}
        </button>
      </motion.form>
    </div>
  );
}
